<template>
    <div class="tab-data-grid">
        <div style="height:100%" v-loading="loading">
            <div class="el-tab-wrap" :class="{'is-default': !custom, 'dis-hover': disHover}">
                <el-tabs v-model="activeName" @tab-click="onTabClick">
                    <template v-for="tab in tabs">
                        <el-tab-pane
                            v-if="$has(tab.code)"
                            :key="tab.name"
                            :name="tab.name"
                            :disabled="tab.disabled"><!--
                        --><div slot="label"><span>{{tab.label}}</span><h-badge :num="tab.num"></h-badge></div><!--
                        --><slot :name="`tab-${tab.name}`"></slot>
                        </el-tab-pane>
                    </template>
                </el-tabs>
            </div>
            <!-- 页签高度40 + 10 -->
            <data-grid v-if="!custom" :diff-height="realTabs.length ? 50 : 0"
                ref="dataGrid"
                :params="params"
                :auto-search="false"
                :api="activeApi"
                :dis-hover="disHover"
                :auto-id="autoId"
                v-model="model"
                :items="realItems">
                <slot/>
                <template slot="operator">
                    <slot name="operator"/>
                </template>
                <template slot="alert">
                    <slot name="alert"/>
                </template>
                <template slot="dialog">
                    <slot name="dialog"/>
                </template>
            </data-grid>
            <template v-else><slot/><slot name="dialog"/></template>
        </div>
    </div>
</template>

<script>
import DataGrid from './data-grid'
import Mixins from './data-grid-mixins.js'
export default {
  name: 'tab-data-grid',
  components: {
    DataGrid
  },
  mixins: [Mixins],
  props: {
    active: {
      type: String,
      default: ''
    },
    tabs: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    custom: {
      type: Boolean,
      default: false
    },
    autoSetActive: { // 是否自动设置激活
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loading: true,
      activeName: '',
      activeApi: '',
      noAuth: false,
      model: {},
      tabItems: []
    }
  },
  computed: {
    realTabs () {
      return this.tabs.filter(t => this.$has(t.code))
    },
    realItems () {
      return this.items.filter(i => {
        if (!i.tab) return true
        else return i.tab === this.activeName
      })
    }
  },
  watch: {
    active: {
      immediate: true,
      handler (value) {
        if (value) {
          this.activeName = value
          this.activeApi = this.getApi()
        }
      }
    },
    tabs: {
      immediate: true,
      deep: true,
      handler (val) {
        // 这里从简处理了，使用了本组件，那么就认为肯定具有tab
        if (val.length > 0 && this.loading) this.loading = false
      }
    },
    loading: {
      immediate: true,
      handler (val) {
        if (!val) {
          this.__init()
        }
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (val !== oldVal) this.model = val
      }
    },
    model: {
      deep: true,
      handler (val, oldVal) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    /**
          * @description 从tabs和select-api中获取api
          * @author yangyu
          */
    getApi () {
      for (let i = 0; i < this.tabs.length; ++i) {
        let tab = this.tabs[i]
        if (this.activeName === tab.name && tab.api) {
          return tab.api
        }
      }
      return this.api
    },
    select (reload) {
      if (!this.noAuth) this.$refs.dataGrid.select(reload)
    },
    onTabClick (tab) {
      this.$emit('update:active', tab.name)
      this.$emit('current-tab-change', tab.name)  
      // 判断是否为自定义
      if (this.custom) {
        let index = this.tabItems.findIndex(item => item.name === tab.name)
        if (index !== -1) {
          this.$nextTick(() => {
            this.tabItems[index].onCurrentChange()
          })
        }
      } else {
        this.activeApi = this.getApi()
        this.$nextTick(() => {
          if (this.autoSearch) this.select(true)
        })
      }
    },
    __init () {
      // 设置默认的tab
      let t = this.tabs.filter(t => this.$has(t.code))
      if (t && t.length) {
        if (this.autoSetActive) this.activeName = t.findIndex(tt => tt.name === this.active) === -1 ? t[0].name : this.active
        else this.activeName = this.active
        if (this.activeName !== this.active) {
          this.onTabClick(t[0]) // 如果未提供单独的api，父组件应该接收默认active
        } else {
          this.activeApi = this.getApi()
          this.$nextTick(() => {
            if (this.autoSearch && !this.custom) this.select(true)
          })
        }
      } else this.noAuth = true // 没有权限
    }
  }
}
</script>

<style lang="less">
.tab-data-grid {
  position: relative;
  height: 100%;
  .el-tab-wrap {
    &.is-default {
      background: #fff;
      border-radius: 4px;
      padding: 0 20px;
      margin-bottom: 10px;
      &:not(.dis-hover){
        &:hover {box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);}
      }
    }
    &:not(.is-default) {
      height: 100%;
      .el-tabs, .el-tab-pane {
        height: 100%;
      }
      .el-tabs__header {
        background: #fff;
        border-radius: 4px;
        padding: 0 20px;
        margin-bottom: 10px;
        // &:hover {
        //   box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
        // } 
      }
      &:not(.dis-hover) {
        .el-tabs__header {
          &:hover {
            box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
          }
        }
      }
      .el-tabs__content {
        // 页签高度40
        height: calc(100% - 40px);
        overflow: visible;
      }
    }
    .el-tabs__header.is-top {
      margin-bottom: 0!important;
    }
    .el-tabs__nav-wrap::after {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/tab-data-grid.vue